// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const setWithExpiry = (key: string, value: any, ttl: number) => {
  const item = {
    value,
    expiry: new Date().getTime() + ttl,
  };
  localStorage.setItem(key, JSON.stringify(item));
};

export const getWithExpiry = (key: string) => {
  const itemString = window.localStorage.getItem(key);
  if (!itemString) return null;

  const item = JSON.parse(itemString);
  const isExpired = new Date().getTime() > item.expiry;

  if (isExpired) {
    localStorage.removeItem(key);
    return null;
  }

  return item.value;
};

const EXCLUDED_RECOMMENDATION_WINE_IDS_KEY_PREFIX = "excludedRecommendationWineIds_";
const EXCLUDED_WINE_IDS_TTL_MS = 24 * 60 * 60 * 1000; // 24 hours
const EXCLUDED_WINE_IDS_MAX = 15;

interface ExcludedWineIdsData {
  wineIds: number[];
  timestamp: number;
}

const getStorageKey = (memberId: number): string =>
  `${EXCLUDED_RECOMMENDATION_WINE_IDS_KEY_PREFIX}${memberId}`;

export const getExcludedWineIds = (memberId: number): number[] => {
  const storedData = localStorage.getItem(getStorageKey(memberId));
  if (!storedData) return [];

  try {
    const data: ExcludedWineIdsData = JSON.parse(storedData);

    if (Date.now() - data.timestamp > EXCLUDED_WINE_IDS_TTL_MS) {
      localStorage.removeItem(getStorageKey(memberId));
      return [];
    }

    return data.wineIds ?? [];
  } catch {
    localStorage.removeItem(getStorageKey(memberId));
    return [];
  }
};

export const addExcludedWineId = (memberId: number, wineId: number): number[] => {
  if (!Number.isInteger(memberId) || memberId <= 0) return [];
  if (!Number.isInteger(wineId) || wineId <= 0) return [];

  const existing = getExcludedWineIds(memberId);
  if (existing.includes(wineId)) return existing;

  const trimmed =
    existing.length >= EXCLUDED_WINE_IDS_MAX ? existing.slice(-EXCLUDED_WINE_IDS_MAX + 1) : existing;
  const updated = [...trimmed, wineId];
  const data: ExcludedWineIdsData = {
    wineIds: updated,
    timestamp: Date.now(),
  };
  localStorage.setItem(getStorageKey(memberId), JSON.stringify(data));
  return updated;
};
